import { Route } from '@angular/router';
import {
  AppFrameComponent,
  LoginIfNotAuthenticated,
  LoginRedirect,
  LoginRedirectComponent,
} from '@unicup-ticketing/core';
import { UnauthorizedComponent } from '@unicup-ticketing/unauthorized';
import { ProfileComponent } from './app/profile/profile.component';

export const appRoutes: Route[] = [
  {
    path: '',
    component: AppFrameComponent,
    children: [
      {
        path: '',
        canActivate: [LoginIfNotAuthenticated],
        children: [
          {
            path: 'profile',
            pathMatch: 'full',
            component: ProfileComponent,
          },
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'profile',
          },
        ],
      },
      {
        path: 'login',
        redirectTo: 'profile',
      },
      {
        path: 'loginRedirect',
        component: LoginRedirectComponent,
        canActivate: [LoginRedirect],
      },
      {
        path: '401',
        component: UnauthorizedComponent,
        data: { redirectToIfLoggedIn: '/' },
      },
      {
        path: 'draws/:drawId/pos',
        loadChildren: () => import('@unicup-ticketing/registration').then(m => m.staffRegistrationRoutes),
        canActivate: [LoginIfNotAuthenticated],
      },
    ],
  },
];
